"use client";
import { useActionsTrack } from "@/_old/features/analytics";
import { Button } from "@woba/ds-web-next";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ExportInsightsConfirmDialog } from "./components/export-insights-confirm-dialog";
import { ExportInsightsGeneratingDialog } from "./components/export-insights-generating-dialog";
import { ReportViewer } from "./components/report-viewer";
import { useReportRequest } from "./hooks/useReportRequest";
import { ReportData, ReportExportButtonProps } from "./types";

export function ActionExportReportInsights({
  filters,
}: ReportExportButtonProps) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const { isGenerating, progress, currentStep, data, start, reset } =
    useReportRequest(filters);
  const [translate] = useTranslation(["dashboard"]);
  const { onActionClick } = useActionsTrack();

  const handleExportClick = () => {
    onActionClick("INSIGHTS_EXPORT_REPORT", "DASHBOARD");
    setShowConfirm(true);
  };

  const handleConfirm = async () => {
    onActionClick("INSIGHTS_EXPORT_REPORT_CONFIRM", "DASHBOARD");
    setShowConfirm(false);
    await start();
    if (data || true) {
      setShowReport(true);
    }
  };

  const handleCloseReport = () => {
    onActionClick("INSIGHTS_EXPORT_REPORT_CLOSE", "DASHBOARD");
    setShowReport(false);
    reset();
  };

  const shouldShowViewer = !isGenerating && !!data && !showReport;
  if (shouldShowViewer) {
    setShowReport(true);
  }

  if (showReport && data) {
    return (
      <ReportViewer
        filters={filters}
        onClose={handleCloseReport}
        reportData={data as ReportData}
      />
    );
  }

  return (
    <>
      <Button
        appearance="primary"
        size="medium"
        className="shrink-0"
        label={
          translate("dashboard-export-report-insights-button-label") as string
        }
        onPress={handleExportClick}
      />

      <ExportInsightsConfirmDialog
        open={showConfirm}
        onOpenChange={setShowConfirm}
        onConfirm={handleConfirm}
        filters={filters}
      />

      <ExportInsightsGeneratingDialog
        open={isGenerating}
        progress={progress}
        currentStep={currentStep}
      />
    </>
  );
}
